import { createMultiLevelFetchId, createGetMultiLevelFetch } from '../fetch'

export const createFetchId = createMultiLevelFetchId('debtor')

export const getDebtor = createGetMultiLevelFetch('debtor')
